<div class="flex gap-x-2">
  <tui-hosted-dropdown
    *tuiLet="pendingProcesses$ | async as pendingProcesses"
    #dropdownComponent
    [content]="content"
  >
    <button tuiButton appearance="outline" size="s" icon="tuiIconChevronDown">
      В очереди {{ pendingProcesses?.length ?? 0 }}
    </button>
    <ng-template #content>
      <tui-data-list role="menu">
        <tui-opt-group>
          @for (item of pendingProcesses; track $index) {
            <button tuiOption>
              {{ item.fileName }}
            </button>
          }
        </tui-opt-group>
      </tui-data-list>
    </ng-template>
  </tui-hosted-dropdown>
  <tui-hosted-dropdown
    *tuiLet="activeProcesses$ | async as activeProcesses"
    #dropdownComponent
    [content]="content"
  >
    <button tuiButton appearance="secondary" size="s" icon="tuiIconChevronDown">
      В обработке {{ activeProcesses?.length ?? 0 }}
    </button>
    <ng-template #content>
      <tui-data-list role="menu">
        <tui-opt-group>
          @for (item of activeProcesses; track $index) {
            <button tuiOption>
              {{ item.startTime | date: 'dd.MM.yyyy HH:mm:ss' }} |
              {{ item.fileName }}
            </button>
          }
        </tui-opt-group>
      </tui-data-list>
    </ng-template>
  </tui-hosted-dropdown>

  <tui-hosted-dropdown
    *tuiLet="errorProcesses$ | async as errorProcesses"
    #dropdownComponent
    [content]="content"
  >
    <button
      tuiButton
      appearance="custom-error"
      size="s"
      icon="tuiIconChevronDown"
    >
      Ошибка {{ errorProcesses?.length ?? 0 }}
    </button>
    <ng-template #content>
      <tui-data-list role="menu">
        <tui-opt-group>
          @for (item of errorProcesses; track $index) {
            <button tuiOption>
              {{ item.endTime | date: 'dd.MM.yyyy HH:mm:ss' }} |
              {{ item.fileName }}
            </button>
          }
        </tui-opt-group>
      </tui-data-list>
    </ng-template>
  </tui-hosted-dropdown>
</div>
